import { type FC } from 'react';
import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { LOGIN_PAGE_URL } from '@/api/core/links';

const Error500: FC = () => {
  return (
    <>
      {/* begin::Title */}
      <h1 className="fw-bolder fs-2qx text-gray-900 mb-4">Erro 500</h1>
      {/* end::Title */}

      {/* begin::Text */}
      <div className="fw-semibold fs-6 text-gray-500 mb-7">Algo deu errado! Por favor, tente novamente mais tarde.</div>
      {/* end::Text */}

      {/* begin::Illustration */}
      <div className="mb-11">
        <img alt="" className="mw-100 mh-300px theme-light-show" src={toAbsoluteUrl('media/auth/500-error.png')} />
        <img alt="" className="mw-100 mh-300px theme-dark-show" src={toAbsoluteUrl('media/auth/500-error-dark.png')} />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      <div className="mb-0">
        <Link className="btn btn-sm btn-primary" to={LOGIN_PAGE_URL}>
          Voltar para o painel
        </Link>
      </div>
      {/* end::Link */}
    </>
  );
};

export { Error500 };
